// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c33e1485","455":"b23c1b39","977":"03586415"}[chunkId] + ".chunk.js";
};